<div
    class="tag font-sm d-flex align-items-center"
    [ngClass]="[outline() ? 'outline' : '', colour() ?? '']"
>
    @if (icon()) {
        <i class="pe-1" [ngClass]="icon()"></i>
    }
    {{ text() }}
</div>
